import watchClassify from './classify'
import watchGetKeyMetrics from './getKeyMetrics'
import watchGetSuggestions from './getSuggestions'

export default [watchClassify, watchGetKeyMetrics, watchGetSuggestions]
